module.exports = __webpack_public_path__ + "img/zhanwei.af8f1b2d.svg";